export default __webpack_public_path__ + "images/AQ.bd0def2.png";